export const noOne = {
  value: "No one",
  displayItem: "No one",
  searchable: "No one"
}